<mat-form-field [floatLabel]="hasFloatingLabel ? 'always' : 'auto'">
    <mat-label>{{ placeholderKey | translate }}</mat-label>
    <input
        matInput
        [ngStyle]="customStyle"
        id="{{ tagId }}"
        type="{{ type }}"
        (blur)="onBlur()"
        (input)="onInput($event)"
        [placeholder]="!!inputPlaceholderKey ? (inputPlaceholderKey | translate) : ''"
        [formControl]="control | formControl"
        [disabled]="isDisabled"
        [attr.maxlength]="maxLength"
        [attr.minlength]="minLength"
        [attr.size]="inputSize"
        [attr.min]="minValue"
        [attr.max]="maxValue"
        #inputField />
    <mat-error>
        <sl-form-field-error-control [control]="control" />
    </mat-error>
</mat-form-field>
